<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <el-form-item label="vip卡ID">
        <el-input
          v-model="formInline.vipcardid"
          placeholder="请输入vip卡ID"
        ></el-input>
      </el-form-item>

      <agentVendorShop @select="selectHandler" />

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="vipcardid" label="VIP卡编号"></el-table-column>
      <el-table-column prop="vipcardName" label="VIP卡名称"></el-table-column>
      <el-table-column label="vip卡卖出份数">
        <template slot-scope="scope">{{ scope.row.soldCount }}</template>
      </el-table-column>
      <el-table-column label="vip总限制使用次数">
        <template slot-scope="scope">{{ scope.row.totalLimitCount }}</template>
      </el-table-column>
      <el-table-column label="每日最大使用次数">
        <template slot-scope="scope">{{ scope.row.dailyLimitCount }}</template>
      </el-table-column>
      <el-table-column label="每周最大使用次数">
        <template slot-scope="scope">{{ scope.row.weeklyLimitCount }}</template>
      </el-table-column>
      <el-table-column label="产品">
        <template slot-scope="scope">
          {{ scope.row.limitedProductType | filterProductType }}
        </template>
      </el-table-column>
      <el-table-column label="是否有效">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isEnable">是</el-tag>
          <el-tag type="warning" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否可售卖">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isSell">可售卖</el-tag>
          <el-tag type="warning" v-else>非卖</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="售价">
        <template slot-scope="scope">{{ scope.row.price + "元" }}</template>
      </el-table-column>
      <el-table-column label="门店">
        <template slot-scope="scope">{{
          getShopsInStrings(scope.row.shops)
        }}</template>
      </el-table-column>
      <el-table-column label="可用时长">
        <template slot-scope="scope"
          >{{ scope.row.dayCount }}天</template
        >
      </el-table-column>
      <el-table-column label="加盟商" v-if="userType === 'admin'">
        <template slot-scope="scope">
          {{ $getVendorName(scope.row.vendorid) }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-popover
            placement="left"
            width="480"
            trigger="click"
            @after-enter="setActiveItem(scope.row.vipcardid)"
          >
            <el-form
              :model="dynamicValidateForm"
              ref="dynamicValidateForm"
              label-width="100px"
              class="demo-dynamic"
            >
              <el-form-item label="优惠券ID">
                <el-input
                  v-model="selectedVipid"
                  style="width:160px;"
                  :readonly="true"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-for="(username, index) in dynamicValidateForm.userMobiles"
                :label="'手机'"
                :key="index"
                :prop="'userMobiles.' + index + '.value'"
                :rules="[
                  {
                    required: true,
                    message: '手机号不能为空'
                  },
                  {
                    pattern: /^1\d{10}$/,
                    message: '请输入正确手机号'
                  }
                ]"
              >
                <el-input
                  v-model="username.value"
                  style="width:160px;"
                ></el-input>
                <el-button
                  type="danger"
                  style="margin-left:1em;"
                  size="mini"
                  @click.prevent="removeUsername(username)"
                  v-if="index > 0"
                  >删除</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" @click="submitForm()"
                  >分配给用户</el-button
                >

                <el-button type="default" size="mini" @click="resetUsername"
                  >重置</el-button
                >
                <el-button
                  type="success"
                  icon="el-icon-circle-plus-outline"
                  size="mini"
                  @click="addUsername"
                  >新增手机</el-button
                >
              </el-form-item>
            </el-form>
            <el-button type="text" slot="reference">分配</el-button>
          </el-popover>
          <el-button
            style="margin-left:15px"
            type="text"
            @click="handleQueryUserByVipcardid(scope.row)"
            >用户</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <EditDialog
      v-if="isDialogShow"
      :isCreate="isCreate"
      :vipItem="vipItem"
      @closeForm="closeForm"
      @refreshData="onSubmit"
    />

    <el-dialog
      :title="'用户'"
      :visible.sync="isDialogQueryUserShow"
      width="40%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
    >
      <el-table :data="userData" style="width: 100%">
        <el-table-column prop="username" label="用户名"> </el-table-column>
        <el-table-column prop="startDate" label="开始日期">
          <template slot-scope="scope">
            <div>{{ scope.row.startDate | formatDateTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="expireDate" label="结束日期">
          <template slot-scope="scope">
            <div>{{ scope.row.expireDate | formatDateTime }}</div>
          </template></el-table-column
        >
      </el-table>
      <el-pagination
        @current-change="handleCurrentChangeUserQuery"
        :current-page.sync="pageUserByVipcardid.currentPage"
        :page-size="pageUserByVipcardid.pageSize"
        layout="total, prev, pager, next"
        :total="pageUserByVipcardid.total"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import agentVendorShop from "@/components/layout/agentVendorShop";
import EditDialog from "./components/editDialog";
import Vip from "../../plugins/VipClass";
//import { mapGetters } from "vuex";
export default {
  components: {
    agentVendorShop,
    EditDialog
  },
  data() {
    return {
      formInline: {
        vendorid: undefined,
        shopid: undefined,
        vendorName: "",
        shopName: ""
      },
      isDialogShow: false,
      isCreate: true,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      userData: [],
      pageUserByVipcardid: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: [],
      // vendorsList: [],
      // shopList: [],
      vipItem: null,
      vendorListForPrompt: [],
      shopListForPrompt: [],
      dynamicValidateForm: {
        userMobiles: [
          {
            value: ""
          }
        ]
      },
      isDialogQueryUserShow: false,
      selectedVipid: "",
      lookUserVipcardid: "",
      userType: this.$getUserType()
    };
  },

  filters: {
    filterProductType(val) {
      return Vip.limitedProductTypeList().find(ele => ele.id === val).name;
    },
    filterType(val) {
      return Vip.typeList().find(ele => ele.id === val).name;
    }
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.shopid = x.selectedShop.shopid;
    },
    onAdd() {
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleEdit(item) {
      this.vipItem = item;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    onSubmit() {
      this.queryVip();
    },
    closeForm() {
      this.isDialogShow = false;
    },
    queryVip() {
      this.$axios(this.$urlMapping["查询VIP"], {
        data: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          ...this.formInline
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    async handleQueryUserByVipcardid(item) {
      //console.log(item);
      this.isDialogQueryUserShow = true;
      this.lookUserVipcardid = item.vipcardid;
      (this.pageUserByVipcardid = {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }),
        await this.queryUserByVipcardid();
    },

    queryUserByVipcardid() {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询vip卡用户关系"], {
          data: {
            vipcardid: this.lookUserVipcardid,
            pageNum: this.pageUserByVipcardid.currentPage,
            pageSize: this.pageUserByVipcardid.pageSize
          }
        }).then(result => {
          this.userData = result.data;
          this.pageUserByVipcardid.total = result.totalCount;
          this.pageUserByVipcardid.currentPage = result.pageNum;
          console.log(result);
          resolve();
        });
      });
    },

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },

    handleCurrentChangeUserQuery(currentPage) {
      this.pageUserByVipcardid.currentPage = currentPage;
      this.queryUserByVipcardid();
      // this.onSubmit();
    },
    // filterVendor(vendorid) {
    //   let vendorNameItem = this.vendorsList.find(
    //     ele => ele && ele.vendorid === vendorid
    //   );
    //   if (vendorNameItem) {
    //     return vendorNameItem.vendorName;
    //   } else {
    //     return "无效的vendor【" + vendorid + "】";
    //   }
    // },
    handleDelete(item) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let vipcardids = [item.vipcardid];
        this.$axios(this.$urlMapping["删除VIP"], {
          data: {
            vipcardids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    removeUsername(item) {
      var index = this.dynamicValidateForm.userMobiles.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.userMobiles.splice(index, 1);
      }
    },
    addUsername() {
      this.dynamicValidateForm.userMobiles.push({
        value: ""
      });
    },
    resetUsername() {
      this.dynamicValidateForm = {
        userMobiles: [
          {
            value: ""
          }
        ]
      };
    },
    submitForm() {
      this.$axios(this.$urlMapping["分配VIP"], {
        data: {
          vipcardid: this.selectedVipid,
          userMobiles: this.dynamicValidateForm.userMobiles.map(
            ele => ele.value
          )
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        // setTimeout(() => {
        //   window.location.reload(false);
        // }, 500);
      });
    },
    setActiveItem(vipcardid) {
      this.selectedVipid = vipcardid;
    },
    getShopsInStrings(shops) {
      let list = [];
      if (shops) {
        shops.forEach(ele => {
          list = list.concat(Object.values(ele));
        });
        return list.join(",");
      }
    }
  },

  watch: {
    "formInline.vendorName": {
      handler(newName, oldName) {
        if (newName != oldName) {
          //console.log("vendorName changed" + newName + oldName);
          this.formInline.vendorid = this.$getVendorID(newName);
          // //这个if，目的就是首次打开这个页面的时候，这动作不要做，免得影响首次数据的加载
          // if (oldName != "") {
          //   this.formInline.shopName = "";
          //   this.formInline.shopid = "";
          // }

          if (this.formInline.vendorid) {
            //this.queryShopForPrompt();
            this.$queryShopForPrompt(this.formInline.vendorid, result => {
              this.shopListForPrompt = result;
            });
          } else {
            this.shopListForPrompt = [];
          }
        }
      }
    },
    "formInline.shopName": {
      handler(newName, oldName) {
        if (newName != oldName) {
          //console.log("shopName changed" + newName + oldName);
          this.formInline.shopid = this.$getShopID(newName);
        }
      }
    }
  },

  async mounted() {
    if (this.userType === "admin") {
      // await new Promise(resolve => {
      //   this.$axios(this.$urlMapping["查询加盟商"], {
      //     data: {}
      //   }).then(result => {
      //     this.vendorsList = result.data;
      //     resolve();
      //   });
      // });

      this.$queryVendorForPrompt(null, result => {
        this.vendorListForPrompt = result;
      });
    }

    this.queryVip();
  }
};
</script>

<style lang="less" scoped></style>
